import { VerticalContainer } from '@american-autonomy/ag-ui';

import useData from './hooks/useData';

import HealthMetricRow from './components/HealthMetricRow';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneHealthTab: FunctionComponent<Props> = ({ className = '', drone, testId = TEST_ID }) => {
    const { metrics } = useData({ drone });

    return (
        <VerticalContainer className={`${className} ${styles.droneHealthTab}`} testId={testId}>
            <VerticalContainer className={styles.metrics}>
                {metrics.map(metric => (
                    <HealthMetricRow key={metric.label} label={metric.label} value={metric.value} />
                ))}
            </VerticalContainer>
        </VerticalContainer>
    );
};

export default DroneHealthTab;
